class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

let discountAppTimeout;
const discountAppObserver = new MutationObserver(function (mutations) {
  const classNames = ['drawer', 'sc_code-btn'];
  if (document.querySelector('.scDiscount__container') == undefined) return;
  mutations.forEach((mutation) => {
    if (classNames.some((className) => mutation.target.classList.contains(className))) {
      let discountBadgeButtons = document.querySelectorAll('.sc_simple-info button');
      discountBadgeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          cartTotalRender();
        });
      });

      let discountAppElms = document.querySelectorAll('.scDiscount__container');
      discountAppElms.forEach((elm) => {
        if (elm.querySelector('.left') == undefined) {
          let discountInputLabel = document.createElement('div');
          discountInputLabel.innerText = 'Discount code';
          discountInputLabel.classList.add('left');
          elm.prepend(discountInputLabel);
        }

        let totalLabel = elm.querySelector('.sc_simple-info__row:not(.sc_code-info) strong');
        if (totalLabel != undefined) {
          totalLabel.innerText = 'Total';
        }
      });

      let discountInputs = document.querySelectorAll('.sc-cube-text');
      discountInputs.forEach((input) => {
        input.addEventListener('change', (e) => {
          cartTotalRender();
        });

        input.addEventListener('keypress', (e) => {
          if (e.key == 'Enter') {
            cartTotalRender();
          }
        });
      });
    }
  });
});

discountAppObserver.observe(document.body, {
  attributes: true,
  childList: true,
  characterData: false,
  subtree: true,
});

function cartTotalRender() {
  clearTimeout(discountAppTimeout);
  document.querySelector('.cart__summary')?.classList.add('loading');
  document.querySelector('.cart-drawer__discounts')?.classList.add('loading');
  discountAppTimeout = setTimeout(() => {
    let sectionCartItems = document.querySelector('[id$="cart-items"]');
    let sectionCartDrawer = document.querySelector('[id$="cart-drawer"]');
    fetch(`${routes.cart_url}?section_id=${sectionCartItems?.id.replace('shopify-section-', '')}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let cartSummarySource = html.querySelector('.cart__summary.js-contents');
        let cartSummary = document.querySelector('.cart__summary.js-contents');
        let cartItemsSource = html.querySelector('.cart__items .js-contents');
        let cartItems = document.querySelector('.cart__items .js-contents');
        if (cartSummary && cartSummarySource) {
          cartSummary.innerHTML = cartSummarySource.innerHTML;
        }
        if (cartItems && cartItemsSource) {
          cartItems.innerHTML = cartItemsSource.innerHTML;
        }
      })
      .finally(() => {
        document.querySelector('.cart__summary')?.classList.remove('loading');
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch((e) => {
        console.log(e);
      });

    fetch(`${routes.cart_url}?section_id=${sectionCartDrawer?.id.replace('shopify-section-', '')}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let cartDrawerTotalsSource = html.querySelector('.cart-drawer__footer');
        let cartDrawerTotals = document.querySelector('.cart-drawer__footer');
        let cartDrawerItemsSource = html.querySelector('.drawer__contents.js-contents');
        let cartDrawerItems = document.querySelector('.drawer__contents.js-contents');
        if (cartDrawerTotals && cartDrawerTotalsSource) {
          cartDrawerTotals.innerHTML = cartDrawerTotalsSource.innerHTML;
        }
        if (cartDrawerItems && cartDrawerItemsSource) {
          cartDrawerItems.innerHTML = cartDrawerItemsSource.innerHTML;
        }
      })
      .finally(() => {
        document.querySelector('.cart-drawer__discounts')?.classList.remove('loading');
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch((e) => {
        console.log(e);
      });
  }, 4000);
}
